import React from "react";
import { Modal, Tooltip } from "antd";
import {
  EsvAssignedToCell,
  EsvDataOpsStatusCell,
  EsvReadStatusCell,
  canAssignEsvAction,
  canEditEsvReadStatus,
  canEditEsvStatus,
} from "./EsvDataOpsCell";
import { EsvRowActions } from "./EsvBulkActions";
import {
  actionLabelFor,
  displayCell,
  esvDoneAtLabel,
  esvDoneByLabel,
  formatActionAt,
  isActionRead,
  readStatusTooltip,
} from "./esvActionDisplay";

const DetailField = ({ label, children }) => (
  <div className="EsvActionDetail__Field">
    <span className="EsvActionDetail__Label">{label}</span>
    {children}
  </div>
);

const HeaderItem = ({ label, value }) => (
  <div className="Sample__Modal__HeaderItem">
    <span className="Sample__Modal__HeaderLabel">{label}</span>
    <span className="Sample__Modal__HeaderValue">{value}</span>
  </div>
);

export default function EsvActionDetailModal({
  open,
  record,
  userNames = {},
  markingId = null,
  onToggleRead,
  assigneeOptions = [],
  assigneeLoading = false,
  savingStatusIds = {},
  onAssignTo,
  onDataOpsStatus,
  onCancel,
}) {
  const read = record ? isActionRead(record.is_read) : false;
  const doneAt = record ? esvDoneAtLabel(record) : "-";
  const doneBy = record ? esvDoneByLabel(record, userNames) : "-";

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="ESV Action"
      width={760}
      footer={null}
      centered
      destroyOnClose
      className="EsvActionDetail"
    >
      {record && (
        <div className="EsvActionDetail__Box">
          <div className="EsvActionDetail__Summary Sample__Modal__Header">
            <HeaderItem label="WO ID" value={displayCell(record.workorder_id)} />
            <div className="Sample__Modal__HeaderDivider" />
            <HeaderItem label="Action At" value={formatActionAt(record.action_at)} />
            <div className="Sample__Modal__HeaderDivider" />
            <HeaderItem
              label="Status"
              value={(
                <Tooltip title={readStatusTooltip(record, userNames)}>
                  <span>
                    <EsvReadStatusCell record={record} />
                  </span>
                </Tooltip>
                )}
            />
            <div className="Sample__Modal__HeaderDivider" />
            <HeaderItem
              label="Data Ops Status"
              value={(
                <EsvDataOpsStatusCell record={record} />
                )}
            />
            {(canEditEsvReadStatus() || canEditEsvStatus()) && (
              <span className="EsvActionDetail__HeaderActions">
                <span className="EsvActionDetail__HeaderActionsLabel">Actions</span>
                <EsvRowActions
                  record={record}
                  loading={markingId === record.id || Boolean(savingStatusIds[record.id])}
                  onMarkRead={onToggleRead}
                  onMarkDataOps={onDataOpsStatus}
                />
              </span>
            )}
          </div>
          <div className="EsvActionDetail__Split" />
          <div className="EsvActionDetail__Grid">
            <DetailField label="Customer ID">{displayCell(record.customer_id)}</DetailField>
            <DetailField label="Company">{displayCell(record.company)}</DetailField>
            <DetailField label="Genista ID">{displayCell(record.genista_id)}</DetailField>
            <DetailField label="Action ESV">{actionLabelFor(record)}</DetailField>
            <DetailField label="Test">{displayCell(record.test)}</DetailField>
            <DetailField label="Result">{displayCell(record.result)}</DetailField>
            <DetailField label={read ? "Marked read at" : "Marked unread at"}>{doneAt}</DetailField>
            <DetailField label={read ? "Marked read by" : "Marked unread by"}>{doneBy}</DetailField>
            <DetailField label="Assign To">
              <EsvAssignedToCell
                record={record}
                canEdit={canAssignEsvAction()}
                assigneeOptions={assigneeOptions}
                assigneeLoading={assigneeLoading}
                userNames={userNames}
                onChange={onAssignTo}
              />
            </DetailField>
          </div>
        </div>
      )}
    </Modal>
  );
}
